import { Event, track } from 'app/lib/analytics';
import { useTrackNewListingSource } from 'app/network/listing';
import type { SpecificNavigationProp } from 'app/types/navigation';
import { ListingType } from 'app/types/listing';
import { SharerType } from 'app/types/preferences';

export function useLenderNextScreen(navigation: SpecificNavigationProp<'lenderNext'>) {
  const trackNewListingSource = useTrackNewListingSource();

  const close = () => {
    track(Event.GiveUpOnboarding, { where: 'lender-next' });
    navigation.getParent()?.reset({ routes: [{ name: 'main' }] });
  };

  const createOffer = () => {
    trackNewListingSource('onboardingV2');
    navigation.getParent()?.reset({
      routes: [{ name: 'main' }, { name: 'new', params: { defaultValues: { type: ListingType.offer } } }],
    });
  };

  const openInspiration = () => {
    trackNewListingSource('onboardingV2');
    navigation.navigate('interests', { sharerType: SharerType.lender, skipExplain: true }, { pop: true });
  };

  return { close, createOffer, openInspiration };
}
